<template>
  <div class="seomain sale-staitc">
    <st-header
      title="订单详情"
      :back-able="true"
      :close-able="true"
    >
      <template slot="header-right">
        <span>
          更多
        </span>
      </template>
    </st-header>

    <div class="wrap">
      <div class="sale-amount">
        <div style="height: 51px;text-align: left;padding-left: 18px;line-height: 51px;font-size: 14px;">年度销售额 (RMB)</div>
        <div style="height: 80px;padding-top:9px;font-size: 28px;line-height: 28px;text-align: center;font-weight: bold;">￥88,888.00</div>
      </div>


      <van-tabs v-model:active="actTab" @change="tabChange" class="sale-static-tabs">
        <van-tab v-for="(v, i) in tabs" :key="i" :title="v.text">
          <div :key="i" class="tab-wrap">
            <div class="sale-amounts">
              <div class="sale-amounts-item">
                <div>￥88888888888.00</div>
                <div><div class="amount-title">营业额</div></div>
                <div>去年&nbsp;+￥88888.00</div>
              </div>
              <div class="sale-amounts-item">
                <div>￥88888888888.00</div>
                <div><div class="amount-title">总成本</div></div>
                <div>去年&nbsp;-￥88888.00</div>
              </div>
              <div class="sale-amounts-item">
                <div>￥88888888888.00</div>
                <div><div class="amount-title">毛利润</div></div>
                <div>去年&nbsp;+￥88888.00</div>
              </div>
            </div>

            <div :ref="'staticEchart' + i" style="width: 100%; height: 400px;" class="sale-staitc-echart-wrap"></div>
          </div>
        </van-tab>
      </van-tabs>

      <div class="sale-data-wrap">
        <div style="color: rgba(81, 89, 110, 1);font-size: 16px;line-height: 150%;text-align: left;font-weight: bold;">
          本月数据总览
        </div>
        <div class="sale-data">
          <div 
            class="sale-data-item"
            v-for="(v, i) in saleData"
            :key="i"
          >
            <div class="sale-data-item-title">{{ v.title }}</div>
            <div class="sale-data-item-content" :theme="v.theme">{{ v.content }}</div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StHeader from "@/components/layout/Header.vue";
  import echarts from 'echarts'
export default {
  components: {
    "st-header": StHeader,
  },
  props: {},
  data() {
    return {
      tabs: [
        { text: "年度销售统计", value: 0 },
        { text: "月度销售统计", value: 1 },
        { text: "最近7日销售统计", value: 2 },
      ],
      actTab: 0,
      chartList: [],
      saleData: [
        { title: '营业额', content: '￥888888888', theme: 'black' },
        { title: '营业额', content: '￥888888888', theme: 'black' },
        { title: '营业额', content: '￥888888888', theme: 'red' },
        { title: '营业额', content: '￥888888888', theme: 'red' },
        { title: '营业额', content: '￥888888888', theme: 'red' },
        { title: '营业额', content: '￥888888888', theme: 'red' },
        { title: '营业额', content: '￥888888888', theme: 'blue' },
        { title: '营业额', content: '￥888888888', theme: 'blue' },
        { title: '营业额', content: '￥888888888', theme: 'blue' },
        { title: '营业额', content: '￥888888888', theme: 'green' },
        { title: '营业额', content: '￥888888888', theme: 'green' },
      ],
			
			total: {
				year: {
					pre: 0,
					cur: 0,
				},
				month: {
					pre: 0,
					cur: 0,
				},
				week: {
					pre: 0,
					cur: 0,
				},
			},
    };
  },
  created() {
    this.init();
   
  },
  mounted() {
    this.renderChart();
  },
  computed: {
    
  },
  watch: {},
  methods: {
    // 初始化
    init() {
      this.setChartData();
			this.getChartData();
    },
    // 设置
    setChartData() {
      this.chartList = [
        {
          legend: {
              data: ['销售额', '订单量'],
              bottom: 10
          },
          xAxis: {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisLabel: {
              rotate: 290 // 旋转角度，单位为度
            }
          },
          yAxis: {
            type: 'value'
          },
        
          series: [{
            name: '销售额',
            data: [2000, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 6600, 6680, 6700],
            type: 'line',
            smooth: true,
            symbol: 'circle', // 设置点为实点
            symbolSize: 8, // 设置点的大小
            lineStyle: {
              color: "rgba(60, 144, 247, 1)" // 设置线为蓝色
            },
            itemStyle: {
              color: "rgba(60, 144, 247, 1)" // 设置点的颜色
            },
          },
          {
            name: '订单量',
            data: [1000, 1500, 1500, 1500, 1500, 1500, 1600, 1700, 1700, 1800, 1800, 2000],
            type: 'line',
            smooth: true,
            symbol: 'circle', // 设置点为实点
            symbolSize: 8, // 设置点的大小
            lineStyle: {
              color: "rgba(85, 191, 192, 1)" // 设置线为蓝色
            },
            itemStyle: {
              color: "rgba(85, 191, 192, 1)" // 设置点的颜色
            }
          }],
        },
        {
          xAxis: {
            type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
          },
          yAxis: {
            type: 'value'
          },
          legend: {
              data: ['销售额', '订单量'],
              bottom: 10
          },
          series: [{
            name: '销售额',
            data: [650, 650, 10, 50, 650, 650, 450, 650, 650, 650, 650, 650, 0, 5, 35, 550, 650, 120, 220, 650, 202, 400, 500, 360, 480, 12, 650, 1, 666, 500],
            type: 'line',
            smooth: true,
            symbol: 'circle', // 设置点为实点
            symbolSize: 6, // 设置点的大小
            lineStyle: {
              color: 'rgba(60, 144, 247, 1)' // 设置线为蓝色
            },
            itemStyle: {
              color: 'rgba(60, 144, 247, 1)' // 设置点的颜色
            }
          }, {
            name: '订单量',
            data: [540, 540, 20, 60, 640, 640, 440, 640, 640, 640, 640, 640, 2, 0, 45, 555, 640, 124, 226, 640, 202, 400, 500, 360, 480, 12, 640, 1, 656, 500],
            type: 'line',
            smooth: true,
            symbol: 'circle', // 设置点为实点
            symbolSize: 8, // 设置点的大小
            lineStyle: {
              color: 'rgba(85, 191, 192, 1)' // 设置线为蓝色
            },
            itemStyle: {
              color: 'rgba(85, 191, 192, 1)' // 设置点的颜色
            }
          }]
        },
        {
          xAxis: {
            type: 'category',
            data: ['04-07', '04-08', '04-09', '04-10', '04-11', '04-12', '04-13']
          },
          yAxis: {
            type: 'value'
          },
          legend: {
            data: ['销售额', '订单量'],
            bottom: 10
          },
          series: [{
            name: '销售额',
            data: [150, 650, 780, 620, 540, 459, 199],
            type: 'line',
            smooth: true,
            symbol: 'circle', // 设置点为实点
            symbolSize: 8, // 设置点的大小
            lineStyle: {
              color: 'rgba(60, 144, 247, 1)' // 设置线为蓝色
            },
            itemStyle: {
              color: 'rgba(60, 144, 247, 1)' // 设置点的颜色
            }
          }, {
            name: '订单量',
            data: [180, 140, 224, 300, 260, 145, 260],
            type: 'line',
            smooth: true,
            symbol: 'circle', // 设置点为实点
            symbolSize: 8, // 设置点的大小
            lineStyle: {
              color: "rgba(85, 191, 192, 1)" // 设置线为绿色
            },
            itemStyle: {
              color: "rgba(85, 191, 192, 1)" // 设置点的绿色
            }
          }]
        },
      ];

      this.chartList.map(item => {
        item.tooltip =  {
          trigger: 'axis',
          formatter: function (params) {
              return `<div class="static-echarts-tooltops" style="background-color: white;color: rgba(81, 81, 81, 1);font-size: 12px;padding: 10px 8px;">
                <div style="width: 6px;height: 6px;display: inline-block;border-radius: 50%;background-color:rgba(60, 144, 247, 1);position:relative;"></div> 销售额  &emsp;  ${params[0].value} <br>
                <div style="width: 6px;height: 6px;display: inline-block;border-radius: 50%;background-color:rgba(85, 191, 192, 1);position:relative;"></div> 订单量  &emsp;  ${params[1].value}
              </div>`;
          }
        }
        return item;
      })
    },

		// 拉起数据
		getChartData() {
			this.$post(this.$api.stGetXiaoshouStatistics, {} ,(res) => {
				if (res.code === 1) {
					console.log('fcl', res);
				} else {
					this.$toast.fail(res.msg ? res.msg : '请求异常，请检查网络，稍后重试！')
				}
			});
		},
		
		// 渲染折线图
    renderChart() {
      this.$nextTick(() => {
        const chart = echarts.init(this.$refs['staticEchart' + this.actTab][0]);
        chart.setOption(this.chartList[this.actTab]);
      });
    },

    // 标签更替
    tabChange(ind) {
      this.actTab = ind;
      this.renderChart();
    },
  },

};
</script>
<style lang="scss" scoped>
.sale-staitc{
  .sale-amount {
    margin: 8px 11px 10px;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(81, 89, 110, 1);
    border-radius: 11px;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
  }

  .tab-wrap{
    color: rgba(80, 80, 80, 1);
    background-color: rgba(255, 255, 255, 1);
    font-size: 14px;

    .sale-amounts {
      display: flex;
      justify-content: space-around;
      text-align: center;
      padding: 14px 0px 6px;

      .sale-amounts-item>div:first-child {
        color: rgba(0, 186, 173, 1);
        font-weight: 600;
      }

      .amount-title {
        width: 106px;
        height: 29px;
        color: rgba(56, 56, 56, 1);
        background-color: rgba(229, 229, 229, 1);
        border-radius: 5px;
        font-size: 12px;
        line-height: 29px;
        text-align: center;
        margin: 6px 0px;
      }
    }
  }
  

  .sale-data-wrap {
    margin: 12px 1px;
    color: rgba(80, 80, 80, 1);
    background-color: rgba(255, 255, 255, 1);
    font-size: 14px;
    line-height: 150%;
    padding-left: 11px;
    padding-top: 13px;

    .sale-data {
      display: flex;
      flex-wrap: wrap;
      
      .sale-data-item {
        margin: 12px 2% 1px 0px;
        width: 31%;
        background-color: rgba(229, 229, 229, 1);
        border-radius: 5px;
        font-size: 14px;
        line-height: 150%;
        margin-right: 2%;

        .sale-data-item-title {
          padding: 7px 10px 21px;
        }

        .sale-data-item-content {
          padding: 7px 6px 9px;
          color: rgba(81, 89, 110, 1);
          text-align: right;
          color: rgba(81, 89, 110, 1);
          font-size: 16px;
          line-height: 150%;
          font-weight: bold;
        }

        [theme="black"] {
          color: rgba(81, 89, 110, 1);
        }

        [theme="red"] {
          color:  rgba(255, 87, 51, 1);
        }
        
        [theme="blue"] {
          color:  rgba(42, 130, 228, 1);
        }

        [theme="green"] {
          color:  rgba(0, 186, 173, 1);
        }
      }
    }
  }
}
</style>

<style>
  .sale-staitc-echart-wrap>div:last-child {
    background-color: rgba(255, 255, 255, 0)!important;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
  }
  .sale-static-tabs .van-tabs__line {
    background-color: rgba(0, 186, 173, 1);
    width: 84px;
  }
</style>
